import React, { useState, useEffect } from 'react';
import { db, getCollectionName } from './firebase';
import { doc, getDoc, setDoc, collection, getDocs } from './firestore-compat';

const C = { border:'#e2e8f0', bg:'#f8fafc', white:'#fff', text:'#1e293b', muted:'#64748b', primary:'#6366f1' };
const inp = { border:`1px solid ${C.border}`, borderRadius:8, padding:'8px 12px', fontSize:'0.85rem', width:'100%', boxSizing:'border-box', outline:'none', color:C.text, background:C.white };
const lbl = { display:'block', fontSize:'0.72rem', fontWeight:700, color:C.muted, marginBottom:4, textTransform:'uppercase', letterSpacing:'0.05em' };
const btn = (bg, col='#fff', extra={}) => ({ background:bg, color:col, border:'none', borderRadius:8, padding:'8px 18px', cursor:'pointer', fontWeight:700, fontSize:'0.84rem', ...extra });

const FUNCOES = ['Médico','Enfermeiro','Fisioterapeuta','Assistente Social'];
const DIAS_SEMANA = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
const uid = () => Math.random().toString(36).slice(2,10);

const CAP_PAD_DISCIPLINES = [
  { key:'fisioterapia',       label:'Fisioterapia' },
  { key:'fonoaudiologia',     label:'Fonoaudiologia' },
  { key:'psicologo',          label:'Psicólogo' },
  { key:'terapeutaOcupacional', label:'Terapeuta Ocupacional' },
  { key:'nutricao',           label:'Nutrição' },
  { key:'tecEnfermagem',      label:'Técnico de Enfermagem' },
  { key:'enfermeiro',         label:'Enfermeiro' },
  { key:'medico',             label:'Médico' },
  { key:'medicoEspecialista', label:'Médico Especialista' },
];

const CAP_PAD_SUBSPECIALTIES = {
  fisioterapia: [
    'Fisioterapeuta','Fisioterapeuta Bobath','Fisioterapeuta Cuevas Medke',
    'Fisioterapeuta Método AME','Fisioterapeuta Método TR3','Fisioterapeuta Neurológica',
    'Fisioterapeuta Pediasuit','Fisioterapeuta RPG','Fisioterapeuta RTA',
    'Fisioterapeuta Urologia','Fisioterapia Motora','Fisioterapia Respiratória',
  ],
  fonoaudiologia: [
    'Fonoaudiologo(a)','Fonoaudiologo(a) Bobath','Fonoaudiologo(a) Laserterapia',
  ],
  psicologo: [
    'Psicologo(a)','Psicomotricidade','Psicopedagoga','Psicoterapia',
  ],
  terapeutaOcupacional: [
    'Terapeuta Ocupacional','Terapia Ocup. Integra Sensorial','Terapia Ocupacional Bobath',
  ],
  medicoEspecialista: [
    'Neurologista','Cardiologista','Pneumologista',
  ],
};

const CAP_FREQUENCIA_OPTIONS = [
  '1x/semana','2x/semana','3x/semana','4x/semana','5x/semana',
  '1x/quinzena','1x/mês','Bimestral','Trimestral','Semestral','Sob demanda','Diário',
];

// ── Form de disponibilidade do profissional ────────────────────────────────────
function ProfForm({ data, isNew, onSave, onCancel }) {
  const [form, setForm] = useState({ ...data });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const toggleDia = (dia) => {
    const exists = form.disponibilidade.find(d => d.dia === dia);
    const disp = exists
      ? form.disponibilidade.filter(d => d.dia !== dia)
      : [...form.disponibilidade, { dia, horaInicio: '08:00', horaFim: '17:00' }];
    set('disponibilidade', disp);
  };
  const updateHorario = (dia, campo, valor) => {
    set('disponibilidade', form.disponibilidade.map(d => d.dia === dia ? { ...d, [campo]: valor } : d));
  };

  return (
    <div style={{ background: '#fff', padding: 20, borderRadius: 10, border: `1px solid ${C.border}` }}>
      <div style={{ fontWeight: 700, fontSize: '0.95rem', color: C.text, marginBottom: 16 }}>
        {isNew ? 'Novo Profissional' : 'Editar Profissional'}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={lbl}>Nome Completo *</label>
          <input style={inp} value={form.nome} onChange={e => set('nome', e.target.value)} placeholder="Nome do profissional" />
        </div>
        <div>
          <label style={lbl}>Função *</label>
          <select style={inp} value={form.funcao} onChange={e => set('funcao', e.target.value)}>
            {FUNCOES.map(f => <option key={f} value={f}>{f}</option>)}
          </select>
        </div>
        <div>
          <label style={lbl}>WhatsApp / Contato</label>
          <input style={inp} value={form.contato} onChange={e => set('contato', e.target.value)} placeholder="(21) 99999-9999" />
        </div>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={lbl}>E-mail de acesso ao Quality (para agenda)</label>
          <input style={inp} type="email" value={form.email || ''} onChange={e => set('email', e.target.value)} placeholder="nome@homebaby.com.br" />
          <span style={{ fontSize: '0.72rem', color: C.muted }}>Usado para que o profissional veja seus agendamentos em Minha Agenda - Captação</span>
        </div>
        <div>
          <label style={lbl}>Status</label>
          <div style={{ display: 'flex', gap: 8 }}>
            {['Ativo', 'Inativo'].map(s => (
              <button key={s} type="button" onClick={() => set('status', s)}
                style={{ ...btn(form.status === s ? (s === 'Ativo' ? '#22c55e' : '#ef4444') : '#f1f5f9', form.status === s ? '#fff' : C.muted), padding: '6px 14px', fontSize: '0.78rem' }}>
                {s}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div style={{ background: C.bg, borderRadius: 10, padding: 14, border: `1px solid ${C.border}`, marginBottom: 14 }}>
        <label style={{ ...lbl, marginBottom: 10 }}>📅 Disponibilidade Semanal</label>
        <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
          {DIAS_SEMANA.map((d, i) => {
            const ativo = form.disponibilidade.find(x => x.dia === i);
            return (
              <button key={d} onClick={() => toggleDia(i)} type="button"
                style={{ padding: '5px 11px', borderRadius: 20, border: `2px solid ${ativo ? C.primary : C.border}`, background: ativo ? '#eef2ff' : C.white, color: ativo ? C.primary : C.muted, cursor: 'pointer', fontWeight: 700, fontSize: '0.78rem' }}>
                {d}
              </button>
            );
          })}
        </div>
        {form.disponibilidade.map(d => (
          <div key={d.dia} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: C.primary, minWidth: 30 }}>{DIAS_SEMANA[d.dia]}</span>
            <input type="time" value={d.horaInicio} onChange={e => updateHorario(d.dia, 'horaInicio', e.target.value)} style={{ ...inp, width: 'auto', flex: 1 }} />
            <span style={{ color: C.muted }}>—</span>
            <input type="time" value={d.horaFim} onChange={e => updateHorario(d.dia, 'horaFim', e.target.value)} style={{ ...inp, width: 'auto', flex: 1 }} />
          </div>
        ))}
        {form.disponibilidade.length === 0 && <p style={{ fontSize: '0.78rem', color: C.muted, margin: 0 }}>Clique nos dias para definir a disponibilidade</p>}
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" onClick={onCancel} style={{ ...btn(C.white, C.muted), border: `1px solid ${C.border}` }}>← Voltar</button>
        <button type="button" onClick={() => onSave(form)} disabled={!form.nome.trim()} style={{ ...btn(C.primary), opacity: form.nome.trim() ? 1 : 0.5 }}>
          {isNew ? '✅ Adicionar' : '💾 Salvar'}
        </button>
      </div>
    </div>
  );
}

const CAP_IMPLANTACAO_AREAS = ['Exames','Remoções','Mobiliário','Gases Medicinais','Equipamentos','Prontuário','Farmácia/Suprimentos','Logística'];

const CAP_AREA_SUBITEMS_DEFAULT = {
  'Exames':              ['Hemograma','Bioquímica','Urocultura','Hemocultura','Raio-X Tórax','ECG','Gasometria','Glicemia'],
  'Remoções':            ['Alta Médica Assinada','Laudo de Remoção','Ambulância Solicitada','Acompanhante Confirmado','Relatório de Transferência'],
  'Mobiliário':          ['Cama Hospitalar','Colchão Piramidal','Mesa de Refeição','Poltrona Reclinável','Grade Lateral','Suporte de Soro','Cadeira de Rodas'],
  'Gases Medicinais':    ['Cilindro de O₂','Regulador de Pressão','Máscara de O₂','Cânula Nasal','Umidificador','Oxímetro de Pulso'],
  'Equipamentos':        ['Bomba de Infusão','Monitor Multiparamétrico','Aspirador','Concentrador de O₂','CPAP/BIPAP','Nebulizador','Balança'],
  'Prontuário':          ['Pasta Fixa','Prontuário Rotativo','Prescrição de Enfermagem','Prescrição Médica','Lista de Verificação','Folha de Evolução','Registro de Sinais Vitais'],
  'Farmácia/Suprimentos':['Medicamentos','Material de Curativo','Fraldas','Dieta Enteral','Sondas/Cateteres','Luvas e EPIs'],
  'Logística':           ['Equipe Alocada','Transporte Confirmado','Kit de Alta Preparado','Família Orientada'],
};

// Lista completa de áreas/ocorrências disponíveis no sistema
const TODAS_OCORRENCIAS = [
  {
    categoria: '📋 PAD — Plano de Atenção Domiciliar',
    color: '#7c3aed', bg: '#f5f3ff', border: '#ddd6fe',
    areas: ['PAD', ...CAP_PAD_DISCIPLINES.map(d => `PAD - ${d.label}`)],
  },
  {
    categoria: '📦 Implantação / Internação',
    color: C.primary, bg: '#eef2ff', border: '#c7d2fe',
    areas: CAP_IMPLANTACAO_AREAS,
  },
  {
    categoria: '🎓 Treinamento e Capacitação',
    color: '#0891b2', bg: '#ecfeff', border: '#a5f3fc',
    areas: ['Educação Continuada'],
  },
];

// ── Aba Grupos de Ocorrências ──────────────────────────────────────────────────
function GruposTab() {
  const [grupos, setGrupos] = useState(null);
  const [setoresDisp, setSetoresDisp] = useState([]); // setores_config
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [editando, setEditando] = useState(null);
  const [novoMembro, setNovoMembro] = useState({});

  useEffect(() => {
    getDoc(doc(db, getCollectionName('captacao_config'), 'grupos_implantacao'))
      .then(snap => setGrupos(snap.exists() ? (snap.data().grupos || []) : []))
      .catch(() => setGrupos([]));
    getDocs(collection(db, getCollectionName('setores_config')))
      .then(snap => setSetoresDisp(snap.docs.map(d => d.data().name).filter(Boolean).sort()))
      .catch(() => {});
  }, []);

  const saveGrupos = async (lista) => {
    setSaving(true);
    try {
      await setDoc(doc(db, getCollectionName('captacao_config'), 'grupos_implantacao'), { grupos: lista });
      setGrupos(lista);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch(e) { console.error(e); }
    setSaving(false);
  };

  const toggleArea = (area) => {
    setEditando(prev => {
      const setores = prev.data.setores || [];
      const next = setores.includes(area) ? setores.filter(s => s !== area) : [...setores, area];
      return { ...prev, data: { ...prev.data, setores: next } };
    });
  };

  const addMembro = (idx) => {
    const email = (novoMembro[idx] || '').trim().toLowerCase();
    if (!email) return;
    setEditando(prev => {
      const membros = prev.data.membros || [];
      if (membros.includes(email)) return prev;
      return { ...prev, data: { ...prev.data, membros: [...membros, email] } };
    });
    setNovoMembro(prev => ({ ...prev, [idx]: '' }));
  };

  const removeMembro = (email) => {
    setEditando(prev => ({ ...prev, data: { ...prev.data, membros: (prev.data.membros || []).filter(m => m !== email) } }));
  };

  const saveEdit = () => {
    if (!editando.data.nome?.trim()) return alert('Selecione um setor para o grupo.');
    if (!(editando.data.setores?.length)) return alert('Selecione ao menos uma ocorrência que este setor vai visualizar.');
    const next = editando.idx === -1
      ? [...grupos, { ...editando.data, id: Math.random().toString(36).slice(2,10) }]
      : grupos.map((g, i) => i === editando.idx ? editando.data : g);
    saveGrupos(next);
    setEditando(null);
  };

  const delGrupo = (idx) => { if (window.confirm('Remover grupo?')) saveGrupos(grupos.filter((_, i) => i !== idx)); };

  if (!grupos) return <div style={{ color:C.muted, padding:20 }}>⏳ Carregando...</div>;

  if (editando) {
    const d = editando.data;
    return (
      <div style={{ background:C.white, borderRadius:10, border:`1px solid ${C.border}`, padding:20 }}>
        <div style={{ fontWeight:700, fontSize:'0.95rem', color:C.text, marginBottom:16 }}>
          {editando.idx === -1 ? 'Novo Grupo' : 'Editar Grupo'}
        </div>

        {/* ── 1. Setor ── */}
        <div style={{ marginBottom:18 }}>
          <label style={lbl}>1. Setor *</label>
          <p style={{ margin:'0 0 8px', fontSize:'0.72rem', color:C.muted }}>
            Selecione o setor criado em Configurações → Setores. Se não aparecer, cadastre-o lá primeiro.
          </p>
          {setoresDisp.length === 0 ? (
            <div style={{ background:'#fff7ed', border:'1px solid #fed7aa', borderRadius:8, padding:'10px 14px', fontSize:'0.82rem', color:'#b45309' }}>
              ⚠️ Nenhum setor cadastrado. Vá em <strong>Configurações → Setores</strong> e crie o setor primeiro.
            </div>
          ) : (
            <select
              style={{ ...inp, fontSize:'0.88rem' }}
              value={d.nome || ''}
              onChange={e => setEditando(prev => ({ ...prev, data: { ...prev.data, nome: e.target.value } }))}
            >
              <option value="">— Selecione um setor —</option>
              {setoresDisp.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          )}
        </div>

        {/* ── 2. Ocorrências que este setor vai ver ── */}
        <div style={{ marginBottom:18 }}>
          <label style={lbl}>2. Quais ocorrências este setor vai visualizar? *</label>
          <p style={{ margin:'0 0 10px', fontSize:'0.72rem', color:C.muted }}>
            Membros deste setor verão apenas as ocorrências com estas áreas/disciplinas.
          </p>
          {TODAS_OCORRENCIAS.map(cat => (
            <div key={cat.categoria} style={{ marginBottom:14 }}>
              <div style={{ fontSize:'0.72rem', fontWeight:700, color:cat.color, marginBottom:7, padding:'4px 10px', background:cat.bg, borderRadius:6, border:`1px solid ${cat.border}`, display:'inline-block' }}>
                {cat.categoria}
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(210px,1fr))', gap:5 }}>
                {cat.areas.map(area => {
                  const on = (d.setores || []).includes(area);
                  const isParent = area === 'PAD';
                  return (
                    <label key={area} style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', padding:'6px 10px', borderRadius:8, background:on?cat.bg:C.bg, border:`1.5px solid ${on?cat.color:C.border}` }}>
                      <input type="checkbox" checked={on} onChange={() => toggleArea(area)} style={{ accentColor:cat.color, width:15, height:15, flexShrink:0 }} />
                      <span style={{ fontSize:'0.8rem', color:on?cat.color:C.text, fontWeight:on?700:400 }}>
                        {isParent ? 'Todas as disciplinas PAD' : area}
                      </span>
                    </label>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* ── 3. Membros ── */}
        <div style={{ marginBottom:18 }}>
          <label style={lbl}>3. Membros (e-mails)</label>
          <p style={{ margin:'0 0 8px', fontSize:'0.72rem', color:C.muted }}>Usuários que pertencem a este setor e verão as ocorrências configuradas acima.</p>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:8 }}>
            {(d.membros||[]).map(m => (
              <span key={m} style={{ display:'flex', alignItems:'center', gap:4, background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:20, padding:'3px 10px 3px 12px', fontSize:'0.78rem', color:'#15803d' }}>
                {m}
                <button type="button" onClick={()=>removeMembro(m)} style={{ background:'none', border:'none', cursor:'pointer', color:'#ef4444', fontWeight:800, lineHeight:1, padding:'0 0 0 4px' }}>✕</button>
              </span>
            ))}
            {!(d.membros?.length) && <span style={{ fontSize:'0.78rem', color:C.muted }}>Nenhum membro adicionado</span>}
          </div>
          <div style={{ display:'flex', gap:8 }}>
            <input style={{ ...inp, flex:1, fontSize:'0.82rem' }} value={novoMembro[editando.idx]||''} onChange={e=>setNovoMembro(p=>({...p,[editando.idx]:e.target.value}))} placeholder="email@exemplo.com" onKeyDown={e=>e.key==='Enter'&&addMembro(editando.idx)} />
            <button type="button" onClick={()=>addMembro(editando.idx)} style={{ ...btn('#10b981'), padding:'8px 14px', fontSize:'0.82rem' }}>+ Adicionar</button>
          </div>
        </div>

        <div style={{ display:'flex', gap:8 }}>
          <button type="button" onClick={()=>setEditando(null)} style={{ ...btn(C.white, C.muted), border:`1px solid ${C.border}` }}>← Voltar</button>
          <button type="button" onClick={saveEdit} disabled={saving} style={{ ...btn(C.primary), opacity:saving?0.7:1 }}>{saving?'⏳ Salvando...':'💾 Salvar Grupo'}</button>
          {saved && <span style={{ fontSize:'0.82rem', color:'#15803d', fontWeight:700 }}>✅ Salvo!</span>}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ background:'#eff6ff', borderRadius:10, padding:'12px 16px', marginBottom:20, border:'1px solid #bfdbfe' }}>
        <p style={{ margin:0, fontSize:'0.82rem', color:'#1d4ed8' }}>
          <strong>Grupos de visibilidade de ocorrências.</strong> Vincule um setor (criado em Configurações → Setores) às ocorrências que ele vai gerenciar e adicione os membros. Membros de um grupo veem somente as ocorrências vinculadas ao setor.
        </p>
      </div>

      <button onClick={() => setEditando({ idx:-1, data:{ nome:'', setores:[], membros:[] } })}
        style={{ ...btn(C.primary), marginBottom:16 }}>
        + Novo Grupo
      </button>

      <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
        {grupos.length === 0 && <p style={{ color:C.muted, textAlign:'center', padding:'24px 0' }}>Nenhum grupo criado ainda.</p>}
        {grupos.map((g, i) => (
          <div key={g.id||i} style={{ background:C.bg, borderRadius:10, padding:'12px 16px', border:`1px solid ${C.border}` }}>
            <div style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, fontSize:'0.9rem', color:C.text, marginBottom:4 }}>{g.nome || '—'}</div>
                <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginBottom:6 }}>
                  {(g.setores||[]).map(s => {
                    const isPAD = s === 'PAD' || s.startsWith('PAD -');
                    return (
                      <span key={s} style={{ background: isPAD?'#f5f3ff':'#eef2ff', color: isPAD?'#7c3aed':C.primary, border:`1px solid ${isPAD?'#ddd6fe':'#c7d2fe'}`, borderRadius:20, padding:'2px 10px', fontSize:'0.72rem', fontWeight:700 }}>
                        {s === 'PAD' ? '📋 PAD (todas)' : s}
                      </span>
                    );
                  })}
                </div>
                <div style={{ fontSize:'0.72rem', color:C.muted }}>{(g.membros||[]).length} membro(s): {(g.membros||[]).join(', ') || '—'}</div>
              </div>
              <button onClick={()=>setEditando({idx:i,data:{...g,setores:[...(g.setores||[])],membros:[...(g.membros||[])]}})} style={{ background:'#f1f5f9', border:'none', borderRadius:6, padding:'5px 10px', cursor:'pointer', fontSize:'0.75rem', fontWeight:600, color:C.muted }}>✏️ Editar</button>
              <button onClick={()=>delGrupo(i)} style={{ background:'#fee2e2', border:'none', borderRadius:6, padding:'5px 10px', cursor:'pointer', fontSize:'0.75rem', fontWeight:600, color:'#ef4444' }}>🗑️</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Aba Setores / Sub-itens ────────────────────────────────────────────────────
function SetoresTab() {
  const [subitems, setSubitems] = useState(null); // null = loading
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [novoItem, setNovoItem] = useState({}); // { [area]: string }

  useEffect(() => {
    getDoc(doc(db, getCollectionName('captacao_config'), 'implantacao_subitems')).then(snap => {
      if (snap.exists()) {
        const stored = snap.data() || {};
        setSubitems({ ...CAP_AREA_SUBITEMS_DEFAULT, ...stored });
      } else {
        setSubitems({ ...CAP_AREA_SUBITEMS_DEFAULT });
      }
    }).catch(() => setSubitems({ ...CAP_AREA_SUBITEMS_DEFAULT }));
  }, []);

  const addItem = (area) => {
    const texto = (novoItem[area] || '').trim();
    if (!texto) return;
    if ((subitems[area] || []).includes(texto)) return;
    setSubitems(prev => ({ ...prev, [area]: [...(prev[area] || []), texto] }));
    setNovoItem(prev => ({ ...prev, [area]: '' }));
  };

  const removeItem = (area, item) => {
    setSubitems(prev => ({ ...prev, [area]: prev[area].filter(x => x !== item) }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await setDoc(doc(db, getCollectionName('captacao_config'), 'implantacao_subitems'), subitems);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) { console.error(e); }
    setSaving(false);
  };

  if (!subitems) return <div style={{ color:C.muted, padding:20 }}>⏳ Carregando...</div>;

  return (
    <div>
      <div style={{ background:'#eff6ff', borderRadius:10, padding:'12px 16px', marginBottom:20, border:'1px solid #bfdbfe' }}>
        <p style={{ margin:0, fontSize:'0.82rem', color:'#1d4ed8' }}>
          <strong>Sub-itens por setor de implantação.</strong> Estes itens aparecem como checklist quando um setor é ativado no modal "Em Implantação". Você pode adicionar ou remover itens de cada setor.
        </p>
      </div>

      {CAP_IMPLANTACAO_AREAS.map(area => (
        <div key={area} style={{ background:C.bg, borderRadius:10, padding:'14px 16px', marginBottom:12, border:`1px solid ${C.border}` }}>
          <div style={{ fontWeight:700, fontSize:'0.9rem', color:C.text, marginBottom:10 }}>📦 {area}</div>

          {/* Lista atual */}
          <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:10 }}>
            {(subitems[area] || []).map(item => (
              <span key={item} style={{ display:'flex', alignItems:'center', gap:4, background:'#eef2ff', border:'1px solid #c7d2fe', borderRadius:20, padding:'3px 10px 3px 12px', fontSize:'0.78rem', color:C.primary }}>
                {item}
                <button type="button" onClick={() => removeItem(area, item)}
                  style={{ background:'none', border:'none', cursor:'pointer', color:'#ef4444', fontWeight:800, fontSize:'0.85rem', lineHeight:1, padding:'0 0 0 4px' }}>✕</button>
              </span>
            ))}
            {(subitems[area] || []).length === 0 && <span style={{ fontSize:'0.78rem', color:C.muted }}>Nenhum item cadastrado</span>}
          </div>

          {/* Adicionar item */}
          <div style={{ display:'flex', gap:8 }}>
            <input style={{ ...inp, flex:1, fontSize:'0.82rem' }}
              value={novoItem[area] || ''}
              onChange={e => setNovoItem(prev => ({ ...prev, [area]: e.target.value }))}
              placeholder={`Novo item para "${area}"...`}
              onKeyDown={e => e.key === 'Enter' && addItem(area)} />
            <button type="button" onClick={() => addItem(area)} style={{ ...btn('#10b981'), padding:'8px 14px', fontSize:'0.82rem' }}>+ Adicionar</button>
          </div>
        </div>
      ))}

      <div style={{ display:'flex', alignItems:'center', gap:12, marginTop:8 }}>
        <button onClick={handleSave} disabled={saving} style={{ ...btn(C.primary), opacity:saving?0.7:1 }}>
          {saving ? '⏳ Salvando...' : '💾 Salvar Setores'}
        </button>
        {saved && <span style={{ fontSize:'0.82rem', color:'#15803d', fontWeight:700 }}>✅ Salvo com sucesso!</span>}
      </div>
    </div>
  );
}

// ── Aba Frequências PAD ────────────────────────────────────────────────────────
function FreqPadTab() {
  const [freqs, setFreqs] = useState({});
  const [opcoes, setOpcoes] = useState([...CAP_FREQUENCIA_OPTIONS]);
  const [novaOpcao, setNovaOpcao] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    getDoc(doc(db, getCollectionName('captacao_config'), 'pad_frequencias')).then(snap => {
      if (snap.exists()) {
        const { _opcoes, ...freqData } = snap.data() || {};
        setFreqs(freqData);
        if (_opcoes && _opcoes.length > 0) setOpcoes(_opcoes);
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const setFreq = (key, value) => setFreqs(prev => ({ ...prev, [key]: value }));

  // Criar/remover opção grava na hora (antes só gravava no "Salvar Frequências" lá embaixo — a opção
  // criada sumia ao sair da tela; relatado em 21/10).
  const gravar = async (novasOpcoes, novasFreqs) => {
    setSaving(true);
    try {
      await setDoc(doc(db, getCollectionName('captacao_config'), 'pad_frequencias'), { ...novasFreqs, _opcoes: novasOpcoes });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      console.error(e);
      alert('Não foi possível salvar as frequências: ' + (e.message || e));
    }
    setSaving(false);
  };

  const addOpcao = () => {
    const texto = novaOpcao.trim();
    if (!texto || opcoes.includes(texto)) return;
    const novas = [...opcoes, texto];
    setOpcoes(novas);
    setNovaOpcao('');
    gravar(novas, freqs);
  };

  const removeOpcao = (opc) => {
    const novas = opcoes.filter(x => x !== opc);
    const novasFreqs = { ...freqs };
    Object.keys(novasFreqs).forEach(k => { if (novasFreqs[k] === opc) novasFreqs[k] = ''; });
    setOpcoes(novas);
    setFreqs(novasFreqs);
    gravar(novas, novasFreqs);
  };

  const handleSave = () => gravar(opcoes, freqs);

  if (loading) return <div style={{ color:C.muted, padding:20 }}>⏳ Carregando...</div>;

  return (
    <div>
      <div style={{ background:'#eff6ff', borderRadius:10, padding:'12px 16px', marginBottom:20, border:'1px solid #bfdbfe' }}>
        <p style={{ margin:0, fontSize:'0.82rem', color:'#1d4ed8' }}>
          <strong>Frequências padrão do PAD.</strong> Estes valores serão exibidos como sugestão ao preencher o PAD de cada paciente. O usuário pode escolher uma frequência diferente por paciente.
        </p>
      </div>

      {/* ── Gerenciar opções de frequência ── */}
      <div style={{ background:C.bg, borderRadius:10, padding:'14px 16px', marginBottom:18, border:`1px solid ${C.border}` }}>
        <div style={{ fontWeight:700, fontSize:'0.88rem', color:C.text, marginBottom:10 }}>🔧 Opções de Frequência Disponíveis</div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:10 }}>
          {opcoes.map(opc => (
            <span key={opc} style={{ display:'flex', alignItems:'center', gap:4, background:'#eef2ff', border:'1px solid #c7d2fe', borderRadius:20, padding:'3px 10px 3px 12px', fontSize:'0.78rem', color:C.primary }}>
              {opc}
              <button type="button" onClick={() => removeOpcao(opc)}
                style={{ background:'none', border:'none', cursor:'pointer', color:'#ef4444', fontWeight:800, fontSize:'0.85rem', lineHeight:1, padding:'0 0 0 4px' }}>✕</button>
            </span>
          ))}
          {opcoes.length === 0 && <span style={{ fontSize:'0.78rem', color:C.muted }}>Nenhuma opção cadastrada</span>}
        </div>
        <div style={{ display:'flex', gap:8 }}>
          <input
            style={{ ...inp, flex:1, fontSize:'0.82rem' }}
            value={novaOpcao}
            onChange={e => setNovaOpcao(e.target.value)}
            placeholder="Ex: 7x/semana, Sob prescrição..."
            onKeyDown={e => e.key === 'Enter' && addOpcao()} />
          <button type="button" onClick={addOpcao} style={{ ...btn('#10b981'), padding:'8px 14px', fontSize:'0.82rem' }}>+ Criar</button>
        </div>
      </div>

      {/* ── Frequência padrão por especialidade ── */}
      {CAP_PAD_DISCIPLINES.map(disc => {
        const subs = CAP_PAD_SUBSPECIALTIES[disc.key];
        return (
          <div key={disc.key} style={{ background:C.bg, borderRadius:10, padding:'14px 16px', marginBottom:10, border:`1px solid ${C.border}` }}>
            <div style={{ fontWeight:700, fontSize:'0.9rem', color:C.text, marginBottom: subs ? 10 : 8 }}>{disc.label}</div>
            {subs ? (
              <div style={{ display:'flex', flexDirection:'column', gap:7, paddingLeft:8, borderLeft:`2px solid ${C.primary}40` }}>
                {subs.map(sub => (
                  <div key={sub} style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <span style={{ fontSize:'0.8rem', color:C.text, flex:1 }}>{sub}</span>
                    <select
                      value={freqs[`${disc.key}__${sub}`] || ''}
                      onChange={e => setFreq(`${disc.key}__${sub}`, e.target.value)}
                      style={{ ...inp, width:180, fontSize:'0.8rem' }}
                    >
                      <option value="">— Sem padrão —</option>
                      {opcoes.map(f => <option key={f} value={f}>{f}</option>)}
                    </select>
                  </div>
                ))}
              </div>
            ) : (
              <select
                value={freqs[disc.key] || ''}
                onChange={e => setFreq(disc.key, e.target.value)}
                style={{ ...inp, fontSize:'0.82rem' }}
              >
                <option value="">— Sem padrão —</option>
                {opcoes.map(f => <option key={f} value={f}>{f}</option>)}
              </select>
            )}
          </div>
        );
      })}

      <div style={{ display:'flex', alignItems:'center', gap:12, marginTop:8 }}>
        <button onClick={handleSave} disabled={saving} style={{ ...btn(C.primary), opacity:saving?0.7:1 }}>
          {saving ? '⏳ Salvando...' : '💾 Salvar Frequências'}
        </button>
        {saved && <span style={{ fontSize:'0.82rem', color:'#15803d', fontWeight:700 }}>✅ Salvo com sucesso!</span>}
      </div>
    </div>
  );
}

// ── Painel principal exportado ─────────────────────────────────────────────────
export default function CaptacaoConfigPanel() {
  const [tab, setTab] = useState('profissionais');
  const [convList, setConvList] = useState([]);
  const [novoConv, setNovoConv] = useState('');
  const [profList, setProfList] = useState([]);
  const [editProf, setEditProf] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const cSnap = await getDoc(doc(db, getCollectionName('captacao_config'), 'convenios'));
        if (cSnap.exists()) setConvList(cSnap.data().lista || []);
        const pSnap = await getDoc(doc(db, getCollectionName('captacao_config'), 'profissionais'));
        if (pSnap.exists()) setProfList((pSnap.data().lista || []).map(p => ({ ...p, disponibilidade: p.disponibilidade || [] })));
      } catch (e) { console.warn('CaptacaoConfigPanel load:', e.message); }
      setLoading(false);
    };
    load();
  }, []);

  const saveConvenios = async (lista) => {
    await setDoc(doc(db, getCollectionName('captacao_config'), 'convenios'), { lista });
    setConvList(lista);
  };
  const saveProfissionais = async (lista) => {
    await setDoc(doc(db, getCollectionName('captacao_config'), 'profissionais'), { lista });
    setProfList(lista);
  };

  const addConv = () => {
    if (!novoConv.trim()) return;
    const n = novoConv.trim().toUpperCase();
    if (!convList.includes(n)) saveConvenios([...convList, n].sort());
    setNovoConv('');
  };

  const saveProf = (data) => {
    const next = editProf.idx === -1 ? [...profList, data] : profList.map((x, i) => i === editProf.idx ? data : x);
    saveProfissionais(next);
    setEditProf(null);
  };
  const delProf = (idx) => { if (window.confirm('Remover profissional?')) saveProfissionais(profList.filter((_, i) => i !== idx)); };
  const emptyProf = () => ({ id: uid(), nome: '', funcao: 'Médico', contato: '', email: '', status: 'Ativo', disponibilidade: [] });

  if (loading) return <div style={{ color: C.muted, padding: 20 }}>⏳ Carregando...</div>;

  return (
    <div>
      {/* Tab bar */}
      <div style={{ display: 'flex', borderBottom: `1px solid ${C.border}`, marginBottom: 20 }}>
        {[
          { k:'profissionais', l:'👥 Profissionais' },
          { k:'convenios',     l:'🏥 Convênios' },
          { k:'freqpad',       l:'📋 Frequências PAD' },
          { k:'setores',       l:'📦 Setores' },
          { k:'grupos',        l:'🔐 Grupos' },
        ].map(t => (
          <button key={t.k} onClick={() => { setTab(t.k); setEditProf(null); }}
            style={{ border:'none', background:'none', padding:'10px 18px', cursor:'pointer', fontWeight:tab===t.k?700:500, fontSize:'0.87rem', color:tab===t.k?C.primary:C.muted, borderBottom:tab===t.k?`2px solid ${C.primary}`:'2px solid transparent', marginBottom:-1 }}>
            {t.l}
          </button>
        ))}
      </div>

      {/* ── Profissionais ── */}
      {tab === 'profissionais' && !editProf && (
        <>
          <button onClick={() => setEditProf({ idx: -1, data: emptyProf() })}
            style={{ ...btn(C.primary), marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>
            + Novo Profissional
          </button>
          <div style={{ background: '#eff6ff', borderRadius: 10, padding: '10px 14px', marginBottom: 12, border: '1px solid #bfdbfe', fontSize: '0.8rem', color: '#1d4ed8' }}>
            <strong>Como vincular usuário ↔ agenda:</strong> Edite o profissional e preencha o campo <em>"E-mail de acesso ao Quality"</em> com o mesmo e-mail que ele usa para fazer login. O sistema filtrará a agenda automaticamente.
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {profList.length === 0 && <p style={{ color: C.muted, textAlign: 'center', padding: '24px 0' }}>Nenhum profissional cadastrado</p>}
            {profList.map((p, i) => (
              <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', background: C.bg, borderRadius: 10, border: `1px solid ${p.email ? '#bbf7d0' : C.border}` }}>
                <div style={{ width: 36, height: 36, borderRadius: '50%', background: `${C.primary}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: '0.85rem', color: C.primary, flexShrink: 0 }}>
                  {(p.nome.split(' ').map(w => w[0]).join('').substring(0, 2) || '?').toUpperCase()}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: '0.88rem', color: C.text }}>{p.nome}</div>
                  <div style={{ fontSize: '0.72rem', color: C.muted }}>{p.funcao} · {p.contato || 'sem contato'} · {p.disponibilidade?.length || 0} dia(s)</div>
                  {p.email
                    ? <div style={{ fontSize: '0.7rem', color: '#15803d', fontWeight: 600, marginTop: 2 }}>🔗 {p.email}</div>
                    : <div style={{ fontSize: '0.7rem', color: '#b45309', fontWeight: 600, marginTop: 2 }}>⚠️ Sem e-mail vinculado — não acessa a própria agenda</div>
                  }
                </div>
                <span style={{ background: p.email ? '#f0fdf4' : '#fff7ed', color: p.email ? '#15803d' : '#b45309', border: `1px solid ${p.email ? '#bbf7d0' : '#fed7aa'}`, fontSize: '0.68rem', fontWeight: 700, padding: '2px 8px', borderRadius: 20, whiteSpace: 'nowrap' }}>
                  {p.email ? '✅ Vinculado' : '⚠️ Sem vínculo'}
                </span>
                <span style={{ background: p.status === 'Ativo' ? '#f0fdf4' : '#f1f5f9', color: p.status === 'Ativo' ? '#15803d' : C.muted, fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: 20 }}>{p.status}</span>
                <button onClick={() => setEditProf({ idx: i, data: { ...p } })} style={{ background: '#f1f5f9', border: 'none', borderRadius: 6, padding: '5px 10px', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 600, color: C.muted }}>✏️ Editar</button>
                <button onClick={() => delProf(i)} style={{ background: '#fee2e2', border: 'none', borderRadius: 6, padding: '5px 10px', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 600, color: '#ef4444' }}>🗑️</button>
              </div>
            ))}
          </div>
        </>
      )}

      {tab === 'profissionais' && editProf && (
        <ProfForm data={editProf.data} isNew={editProf.idx === -1} onSave={saveProf} onCancel={() => setEditProf(null)} />
      )}

      {/* ── Convênios ── */}
      {tab === 'convenios' && (
        <>
          <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            <input style={{ ...inp, flex: 1 }} value={novoConv} onChange={e => setNovoConv(e.target.value)} placeholder="Nome do convênio..." onKeyDown={e => e.key === 'Enter' && addConv()} />
            <button onClick={addConv} style={btn(C.primary)}>+ Adicionar</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {convList.map((c, i) => (
              <div key={c} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: C.bg, borderRadius: 8, border: `1px solid ${C.border}` }}>
                <span style={{ fontSize: '0.84rem', color: C.text }}>{c}</span>
                <button onClick={() => saveConvenios(convList.filter((_, idx) => idx !== i))} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '0.9rem', lineHeight: 1 }}>✕</button>
              </div>
            ))}
            {convList.length === 0 && <p style={{ color: C.muted }}>Nenhum convênio cadastrado.</p>}
          </div>
        </>
      )}

      {/* ── Frequências PAD ── */}
      {tab === 'freqpad' && <FreqPadTab />}

      {/* ── Setores ── */}
      {tab === 'setores' && <SetoresTab />}

      {/* ── Grupos ── */}
      {tab === 'grupos' && <GruposTab />}
    </div>
  );
}
